import { jsx as _jsx } from "react/jsx-runtime";
export const CEmail = ({ email }) => (_jsx("a", { href: `mailto:${email}`, children: email }));
